import React from 'react'
import { AddToTrolley } from '@sainsburys-tech/bolt'

const { Modal } = AddToTrolley

const AddToTrolleyModal = props => {
  const { showAddToTrolley, trolleyModalOptions, trolleyTrackingOptions } = props
  if (!showAddToTrolley) {
    return null
  }
  return <Modal {...trolleyModalOptions} {...trolleyTrackingOptions} />
}

export default AddToTrolleyModal
